var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress",style:({ width: ((_vm.total ? (_vm.progress / _vm.total) * 100 : 0) + "%") })})])}
var staticRenderFns = []

export { render, staticRenderFns }